<template>
  <div id="app" class="flex min-h-screen w-full bg-gray-100 relative">
    <checkInternet />
    <tonnageController />
    <serviceRequestController />
    <div
      class="w-full max-h-screen overflow-y-auto bg-gray-200 dark:bg-gray-900"
    >
      <headerItem v-if="$store.state.isAuth" />

      <router-view ref="activePage" />
    </div>
    
    <!-- Yeni Versiyon Bildirimi -->
    <div 
      v-if="updateAvailable" 
      class="fixed bottom-4 right-4 bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4 z-50 max-w-md border-l-4 border-red-500 animate-pulse-border"
    >
      <div class="flex items-start">
        <div class="flex-shrink-0 pt-0.5">
          <i class="fas fa-sync-alt text-red-500 text-xl mr-3"></i>
        </div>
        <div class="ml-3 flex-1">
          <h3 class="text-sm font-medium text-gray-900 dark:text-gray-100">Yeni versiyon mevcut!</h3>
          <div class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            <p>Yeni özellikler ve iyileştirmeler için sayfayı yenileyin.</p>
            <p class="mt-1 text-xs">Versiyon: {{ appVersion }}</p>
          </div>
          <div class="mt-4 flex space-x-3">
            <button
              @click="refreshApp"
              class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Şimdi Yenile
            </button>
            <button
              @click="dismissUpdate"
              class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Daha Sonra
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkInternet from './components/general/network-status.vue'
import LZString from "lz-string";
import headerItem from "../src/partition/header.vue";
import tonnageController from "./components/controller/tonnageController/index.vue";
import serviceRequestController from "./components/controller/serviceRequestController/index.vue";

//Networking
import axios from "axios";
import { user } from "./networking/urlmanager";
import fuelStream from "./services/fuelEventStream";
export default {
  name: "app",
  components: {
    headerItem,
    checkInternet,
    tonnageController,
    serviceRequestController,
  },
  data() {
    return {
      currentPath: "",
      intervalId: null,
      timeoutId: null,
      updateAvailable: false,
      appVersion: window.APP_VERSION || '0.1.5'
    };
  },
  methods: {
    saveCurrentPageData() {
      if (this.$route.name === "loginPage") return;
      this.$store.commit("pages/addPagesDetail", {
        id: this.$route.name,
        data: this.$refs.activePage.$data,
      });
    },
    handleInterval() {
      this.timeoutId = setTimeout(() => {
        if (this.$refs.activePage.needInterval) {
          this.intervalId = setInterval(() => {
            this.$refs.activePage.getAll(false);
          }, 25000);
        } else {
          clearTimeout(this.timeoutId);
        }
      }, 25000);
    },
    refreshApp() {
      // Sayfayı yenile
      window.location.reload(true);
    },
    dismissUpdate() {
      // Güncelleme bildirimini kapat
      this.updateAvailable = false;
    }
  },
  created() {
    // Yeni versiyon mevcut olduğunda bildirim almak için dinleyici ekle
    window.addEventListener('app-update-available', () => {
      this.updateAvailable = true;
      // Versiyon bilgisini güncelle
      this.appVersion = window.APP_VERSION || '0.1.5';

      // Gelişmiş versiyon bilgisi için app-version.json'dan kontrol et
      setTimeout(() => {
        axios.get(`/app-version.json?t=${new Date().getTime()}`)
          .then(response => {
            if (response.data && response.data.version) {
              this.appVersion = response.data.version;
            }
          })
          .catch(error => console.error('Versiyon bilgisi alınamadı:', error));
      }, 1000);
    });

    if (this.$route.name !== "newPassword") {
      axios
        .get(user.signControl, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit("activeLightMode");
          document.documentElement.classList.remove("dark");
          this.$store.commit("signOut");
          this.$router.push("/");
        });
    }

    window.addEventListener("beforeunload", this.saveCurrentPageData);

    if (this.$route.name !== "loginPage") {
      setTimeout(() => {
        const newData = this.$store.state.pages.List.find(
          (item) => item.id == this.$route.name
        )?.data;
        const decompressedData = newData
          ? JSON.parse(LZString.decompress(newData))
          : null;
        if (decompressedData) {
          Object.keys(decompressedData).forEach((key) => {
            this.$refs.activePage.$data[key] = decompressedData[key];
          });
        }
      }, 100);
    }

    this.handleInterval();

    // Yakıt modülü SSE bağlantısını başlat (oturum açıksa)
    const token = this.$store.state.userData?.token;
    if (token) fuelStream.connect(token);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.saveCurrentPageData);
    // Uygulama güncelleme olay dinleyicisini kaldır
    window.removeEventListener('app-update-available', null);
    fuelStream.close();
  },

  watch: {
    $route(to, from) {
      this.currentPath = to.path;

      if (to.name != "loginPage") {
        this.$store.commit("addTab", {
          id: to.name,
          title: to.meta.name,
          url: to.path,
        });
      }
      const tabIndex = this.$store.state.activeTabs.findIndex(
        (i) => i.url === from.path
      );
      if (tabIndex !== -1) {
        if (from.name == "loginPage" || to.name == "loginPage") return;

        
        this.$store.commit("pages/addPagesDetail", {
          id: from.name,
          data: this.$refs.activePage.$data,
        });
      }
      setTimeout(() => {
        const newData = this.$store.state.pages.List.find(
          (item) => item.id == to.name
        )?.data;

        const decompressedData = newData
          ? JSON.parse(LZString.decompress(newData))
          : null;
        if (decompressedData) {
          Object.keys(decompressedData).forEach((key) => {
            this.$refs.activePage.$data[key] = decompressedData[key];
          });
        }
      }, 100);
    },
    currentPath() {
      clearInterval(this.intervalId);
      clearTimeout(this.timeoutId);
      this.handleInterval();
    },
    "$store.state.userData.token"(newToken) {
      // Login/logout veya refresh token sonrası SSE bağlantısını yenile
      if (newToken) {
        fuelStream.refresh(newToken);
      } else {
        fuelStream.close();
      }
    },
  },
};
</script>

<style>
@keyframes pulse-border {
  0%, 100% {
    border-color: rgba(239, 68, 68, 1);
  }
  50% {
    border-color: rgba(239, 68, 68, 0.5);
  }
}

.animate-pulse-border {
  animation: pulse-border 2s ease-in-out infinite;
}
</style>
